import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Services from '../components/Services';
import HowItWorks from '../components/HowItWorks';
import Tracking from '../components/Tracking';
import Stats from '../components/Stats';
import { Areas } from '../components/BlogSection';
import FAQ from '../components/FAQ';
import { HERO_IMAGES } from '../mock';
import { Button } from '../components/ui/button';

const ServicesPage = () => {
  return (
    <>
      <Header />
      <main>
        <section className="relative overflow-hidden bg-[#0A1628]">
          <div className="absolute inset-0 z-0">
            <img src={HERO_IMAGES.expedited} alt="Excelence Inc car hauler with multiple vehicles loaded for nationwide auto transport" className="w-full h-full object-cover opacity-50" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0A1628]/95 via-[#0A1628]/85 to-[#0E2744]/60" />
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28 text-white">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#D4A24C]">Services</span>
            <h1 className="mt-4 text-4xl md:text-6xl font-extrabold leading-[1.05] max-w-3xl">
              End-to-end auto transport, built for every vehicle.
            </h1>
            <p className="mt-5 max-w-2xl text-lg text-white/80">
              From everyday sedans to exotic collectibles — pick the service that fits, and we'll handle the rest.
            </p>
            <div className="mt-8 flex gap-3">
              <a href="/#quote"><Button className="btn-accent font-bold">Get a Quote</Button></a>
              <a href="/contact"><Button variant="outline" className="border-white/30 text-white bg-white/10 hover:bg-white hover:text-[#0A1628] font-semibold">Talk to dispatch</Button></a>
            </div>
          </div>
        </section>
        <Services />
        <HowItWorks />
        <Tracking />
        <Stats />
        <Areas />
        <FAQ />
      </main>
      <Footer />
    </>
  );
};

export default ServicesPage;
